import { Badge, Button, Tooltip } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

/**
 * 顶栏铃铛——通知中心的入口。
 *
 * ⚠️ **本组件只管显示**：未读数由 `NotificationCenter` 查好后传进来。
 * 理由：铃铛与抽屉都要用这个数（角标 / 「全部已读」是否可用）⇒ 放一处查，
 * 两处用；两处各查一次就是两次请求。
 */
export function NotificationBell({
  unread,
  failed,
  onOpen,
}: {
  unread: number;
  /** 未读数取不到 —— 角标不显示，但入口要在（用户得知道出事了）。 */
  failed: boolean;
  onOpen: () => void;
}) {
  const { t } = useTranslation();
  const label = t('notifications.title');
  const title = failed
    ? t('notifications.countFailed')
    : unread > 0
      ? t('notifications.unreadCount', { count: unread })
      : label;
  return (
    <Tooltip title={title}>
      {/*
        角标只在有未读时出现（0 不显示）。
        ⚠️ 用 `count={null}` 而不是「整块 Badge 条件渲染」：条件渲染会让
        按钮在 0 ↔ 非 0 之间**换掉整个元素** ⇒ 焦点丢失、按钮闪一下。
        `null` 让 antd 自己把角标藏起来，按钮始终是同一个元素。
      */}
      <Badge count={unread > 0 ? unread : null} data-testid="notification-badge">
        <Button
          type="text"
          size="small"
          icon={<BellOutlined />}
          aria-label={label}
          onClick={onOpen}
        />
      </Badge>
    </Tooltip>
  );
}
